import React, { useContext, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import axios from 'axios';
import { AppContext } from "../../context/app/appContext";
import { Dimmer, Loader } from "semantic-ui-react";

export const CreatePasswordPage = () => {

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    const appContext = useContext(AppContext);
    const { orgToken } = useParams();
    const history = useHistory();
    console.info({ orgToken });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');

    const handleCreatePassword = async (event) => {
        try {
            setLoading(true);
            event.preventDefault();
            setErrors('');
            console.info(`create-password...`);
            console.info("Verify", { orgToken, password, confirmPassword })
            const response = await axios.post(`${baseURL}/unverified-org/create-password`, { orgToken, password, confirmPassword });
            const unverifiedOrgData = response.data.data;
            console.info(unverifiedOrgData);

            const {
                legalEntityName, mobile, email, firstName, lastName, _id,
                website, entityType, merchantCategoryCode, primaryContactDOB, linkedInProfile, signatoryType,
                street, city, state, country, zip, createdAt, updatedAt, subscription, planType
            } = unverifiedOrgData;

            const unverifiedUser = { accessToken: _id, email, firstName, lastName, };

            const unverifiedOrg = {
                verified: false,
                EIN: '',
                legalEntityName: legalEntityName || '',
                entityType: entityType || 'company',
                merchantCategoryCode: merchantCategoryCode || '',
                website: website || '',
                street: street || '',
                city: city || '',
                state: state || '',
                zip: zip || '',
                country: country || '',
                createdAt: createdAt || '',
                updatedAt: updatedAt || '',
                primaryContact: {
                    firstName: firstName || '',
                    lastName: lastName || '',
                    email,
                    contactNumber: mobile || '',
                    signatoryType: signatoryType || '',
                    linkedInProfile: linkedInProfile || '',
                    dateOfBirth: primaryContactDOB || '',
                },
                secondaryContact: {
                    firstName: '',
                    lastName: '',
                    contactNumber: '',
                    email: '',
                    linkedInProfile: '',
                },
                peopleOpsContact: {
                    firstName: '',
                    lastName: '',
                    phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                    email: '',
                },
                perkBudgetApproverContact: {
                    firstName: '',
                    lastName: '',
                    phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                    email: '',
                },
                subscription,
                planType
            }

            await appContext.setUnverifiedOrganization(unverifiedOrg); // TODO: should be in Organization page load, so that each time it can be reloaded
            await appContext.setUnverifiedUser(unverifiedUser); // TODO: should be in Organization page load, so that each time it can be reloaded
            localStorage.setItem('email', email)
            localStorage.setItem('accessToken', _id)
            setLoading(false);

            console.info('redirecting to my-org');
            history.push("/account");
        } catch (error) {
            setLoading(false);
            console.info({ error });
            if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
        }
    }

    const loader = (
        <Dimmer active>
            <Loader size="large">verifying credentials...</Loader>
        </Dimmer>
    )

    const errorBlock = (
        <div className="ui error message">
            <div className="content">{errors}</div>
        </div>
    );

    return (
        <div id="login-page" className="ui centered two column grid middle aligned">
            <div className="ui segment column login-panel">

                <header>
                    <h1 className="login-logo">Perkfix</h1>
                    <h2>People Ops</h2>
                </header>

                <p className="hint">Create password for your Perkfix.com People Ops platform.</p>

                {loading ? loader : ''}

                {errors ? errorBlock : ''}

                <form className="ui large form center aligned text-center" onSubmit={handleCreatePassword}>
                    <div className="field">
                        <div className="ui fluid input"><input type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} value={password} required /></div>
                    </div>

                    <div className="field">
                        <div className="ui fluid input"><input type="password" placeholder="Confirm Password" onChange={e => setConfirmPassword(e.target.value)} value={confirmPassword} required />
                        </div>
                    </div>

                    {!loading ? (<button className="ui button primary">Create</button>) : ''}
                </form>
            </div>
        </div>
    );
};
